// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__Ohhwg","label":"Radio_label__1ad4d","checkMark":"Radio_checkMark__L6JPG","disabled":"Radio_disabled__1q0cI"};